module.exports = __webpack_public_path__ + "static/img/Error.8b2b3b1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Error.svg
// module id = s0on
// module chunks = 1